import { comics } from './comics';

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类浏览', href: '/category/all' },
  { label: '本周强推', href: '/#featured' },
  { label: '关于我们', href: '/about' },
];

export const footerLinks = {
  explore: [
    { label: '热门漫画', href: '/category/all' },
    { label: '最新上架', href: '/category/all?sort=newest' },
    { label: '完结漫画', href: '/category/all?sort=completed' },
    { label: '高分推荐', href: '/category/all?sort=rating' },
  ],
  categories: [
    { label: '热血漫画', href: '/category/hot-blood' },
    { label: '恋爱漫画', href: '/category/romance' },
    { label: '奇幻漫画', href: '/category/fantasy' },
    { label: '剧情漫画', href: '/category/drama' },
    { label: '惊悚漫画', href: '/category/thriller' },
  ],
  support: [
    { label: '帮助中心', href: '/about' },
    { label: '常见问题', href: '/about#faq' },
    { label: '联系我们', href: '/about#contact' },
    { label: '用户反馈', href: '/about#contact' },
  ],
};

export const siteConfig = {
  name: '韩漫屋',
  tagline: '韩漫免费看 · 下拉式漫画大全',
  description: '韩漫屋 - 韩漫免费看，下拉式漫画大全，韩国漫画在线。友好的界面设计，为您营造温馨舒适的阅读环境。海量韩国漫画免费阅读，随时随地享受流畅的下拉式阅读体验。',
  url: 'https://www.hanmanwu.com',
  logo: '韩漫屋',
  email: 'contact@hanmanwu.com',
  address: '韩国首尔特别市江南区',
  year: 2026,
  social: {
    weibo: '#',
    wechat: '#',
    bilibili: '#',
    xiaohongshu: '#',
  },
};

export { comics };